import type { IconData } from '@stacksjs/iconify-core'

export const cf4x3: IconData = {
  "body": "<defs><clipPath id=\"SVGDjg3edei\"><path fill-opacity=\".7\" d=\"M-12.4 32h640v480h-640z\"/></clipPath></defs><g fill-rule=\"evenodd\" clip-path=\"url(#SVGDjg3edei)\" transform=\"translate(12.4 -32)\"><path fill=\"#00f\" d=\"M-52 32h719.3v119H-52z\"/><path fill=\"#ff0\" d=\"M-52 391.6h719.3V512H-52z\"/><path fill=\"#009a00\" d=\"M-52 271.3h719.3v120.3H-52z\"/><path fill=\"#fff\" d=\"M-52 151h719.3v120.3H-52z\"/><path fill=\"red\" d=\"M247.7 32.5h119.9V512H247.7z\"/><path fill=\"#ff0\" d=\"m99.3 137.7l-31.5-21.8l-31.3 22L47.4 101L16.9 78l38.2-1l12.5-36.3L80.3 77l38.1.7L88.2 101\"/></g>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default cf4x3
